import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Trophy } from "lucide-react";
import { fadeUp } from "./shared";

export function HeroSection() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 flex" aria-hidden="true">
        <img src="/assets/hero-ithra.jpg" alt="" className="w-[62%] h-full object-cover"
          style={{ filter: "blur(3px) saturate(1.15)", transform: "scale(1.07)" }} />
        <img src="/assets/hero-tower.jpg" alt="" className="w-[38%] h-full object-cover"
          style={{ filter: "blur(3px) saturate(1.15)", transform: "scale(1.07)" }} />
        <div className="absolute inset-0"
          style={{ background: "linear-gradient(115deg, rgba(11,110,122,0.88) 0%, rgba(18,147,158,0.62) 45%, rgba(193,80,47,0.45) 100%)" }} />
        <div className="absolute inset-0"
          style={{ background: "linear-gradient(to bottom, transparent 40%, var(--bg) 96%)" }} />
      </div>
      <div className="relative max-w-4xl mx-auto px-5 pt-16 pb-32">
        <motion.div initial="hidden" animate="show" variants={fadeUp} className="text-white text-center">
          <div className="inline-flex items-center gap-2.5 bg-white/15 backdrop-blur-md text-white text-[11px] font-bold pr-1.5 pl-4 py-1.5 rounded-full mb-6 border border-white/20">
            <span className="w-9 h-9 rounded-full bg-white flex items-center justify-center overflow-hidden shadow shrink-0">
              <img src="/assets/moe-logo.png" alt="شعار وزارة التعليم" data-testid="moe-logo-hero" className="w-7 h-7 object-contain"
                onError={(e) => { e.currentTarget.style.display = "none"; }} />
            </span>
            قسم المسؤولية المجتمعية والعمل التطوعي — تعليم المنطقة الشرقية
          </div>
          <h1 className="font-head font-black text-4xl sm:text-6xl leading-[1.25] mb-5 drop-shadow-lg">
            كل ساعة عطاء…
            <span className="text-coral-300"> أثرٌ يُقاس</span>
            <br />وقصّة تُروى
          </h1>
          <p className="text-white/85 leading-relaxed mb-3 max-w-2xl mx-auto text-sm sm:text-base">
            منظومة رقمية موحّدة ترصد الجهد التطوعي لطلاب ومنسوبي مدارس المنطقة الشرقية، وتحوّله إلى مؤشرات عادلة
            وشهادات تقدير وقصص أثر — بحيث يشعر كل منسّق ومتطوع أن جهده مرئي ومُقدَّر لحظة بلحظة.
          </p>
          <p className="font-head font-bold text-coral-300 mb-8 text-sm sm:text-base">«نحو تطوّع مدرسي يبني القيم ويقيس الأثر»</p>
          <div className="flex gap-3 flex-wrap justify-center">
            <Link to="/login" data-testid="hero-cta-login"
              className="rounded-2xl bg-coral-600 hover:bg-coral-900 text-white font-bold px-7 py-3.5 text-sm transition-colors shadow-xl shadow-black/20">
              دخول المنسقين والإدارة
            </Link>
            <a href="#honor" data-testid="hero-cta-honor"
              className="rounded-2xl bg-white/15 backdrop-blur-md border border-white/25 text-white font-bold px-7 py-3.5 text-sm hover:bg-white/25 transition-colors flex items-center gap-2">
              <Trophy className="w-4 h-4" /> لوحة الشرف
            </a>
          </div>
          <div className="inline-flex items-center gap-3 mt-8 bg-white/12 backdrop-blur-md border border-white/20 rounded-2xl px-5 py-2.5">
            <span className="text-[11px] font-bold text-white/80">مؤشر التمكين المستهدف</span>
            <span className="font-head font-black text-2xl text-coral-300">90%</span>
            <span className="text-[11px] text-white/70">يُحتسب بالطلبة الفريدين لا بالساعات</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
